import type {
  CellProps,
  FontSizes
} from "rivals/components/shared/Tables/Cells/types";
import commonStyles from "rivals/styles/exports.module.scss";

export const colors = {
  abyss: commonStyles.abyss,
  callToActionBlue: commonStyles.callToActionBlue
} as const;

export type ColorName = keyof typeof colors;

export interface Props extends CellProps {
  /**
   * The alignment of the text with the cell
   */
  alignment?: "left" | "center" | "right";
  /**
   * Whether the main text should be bold
   */
  bold?: boolean;
  /**
   * Optional eyebrow text or component rendered above the main text
   */
  eyebrow?: string | React.JSX.Element;
  /**
   * The font size of the text
   */
  fontSize?: FontSizes;
  /**
   * Optional footer text or component rendered below the main text
   */
  footer?: string | React.JSX.Element;
  /**
   * The justification of the text with the cell
   */
  justification?: "left" | "center" | "right";
  /**
   * The main text to display in the cell
   */
  text: string | React.JSX.Element;
  /**
   * The color of the text. Defaults to "abyss".
   */
  textColor?: ColorName;
  /**
   * Whether the main text should be uppercase
   */
  uppercase?: boolean;
}
